export default "__VITE_ASSET__t$vLBOA7__"